import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import { environment } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root'
})
export class FormFooterService {
  baseUrl = environment.BASE_URL;
  
  url = this.baseUrl+'/auth-service/signUp';
  constructor (private http : HttpClient) {}
  imcustomer (data:any) {
    var payload = {
      "userDetail": {
          "userName": data.name,
          "email": data.email,
          "status": true,
          "company": "BCG",
          "phone": data.country_code + ' ' + data.contactNumber,
          "userType": "Customer",
          "source": "corporateWebsite",
          "role": "Customer"
      },
      "lead": {
          "industryName": "Aerospace",
          "categoryName": "categoryName",
          "categoryId": 1,
          "countryId": 1,
          "countryName": "India",
          "industryId": 1,
          "status": true 
      },
      "customerCompanyProfile": {
          "name": "BCG",
          "address": "C-62, Indore",
          "stateId": 10,
          "stateName": "Madhya Pradesh",
          "cityId": 101,
          "cityName": "Indore",
          "pincodeId": 11,
          "pincode": "456001"
      }
    }
      return this.http.post(this.url, payload);
  }
  imsupplier (data:any) {
    var payload = {
      "userDetail": {
          "userName": data.name,
          "email": data.email,
          "status": true,
          "company": "BCG",
          "phone": data.country_code + ' ' + data.contactNumber,
          "userType": "Supplier",
          "source": "corporateWebsite",
          "role": "Supplier"
      },
      "lead": {
          "industryName": "Aerospace",
          "categoryName": "categoryName",
          "categoryId": 1,
          "countryId": 1,
          "countryName": "India",
          "industryId": 1,
          "status": true 
      },
      "customerCompanyProfile": {
          "name": "BCG",
          "address": "C-62, Indore",
          "stateId": 10,
          "stateName": "Madhya Pradesh",
          "cityId": 101,
          "cityName": "Indore",
          "pincodeId": 11,
          "pincode": "456001"
      }
    }
      return this.http.post(this.url, payload);
  }
}
